export const EVENT_STATUS_DRAFT = 'draft';
export const EVENT_STATUS_PAST = 'past';
export const EVENT_STATUS_CANCELED = 'canceled';
export const EVENT_STATUS_SENDING = 'sending';

export const USED_AS_INVITATION = 'invitation';
export const USED_AS_SAVE_THE_DATE = 'save_the_date';
export const USED_AS_CARD = 'card';
export const USED_AS_GIFT_CARD = 'gift_card';

// Event Categories - Event Classification
export const TODDLER_CATEGORY = 'Toddler';
export const GET_TOGETHER_CATEGORY = 'Get Together';
export const BABY_CATEGORY = 'Baby';
export const KIDS_BIRTHDAY_CATEGORY = 'Birthday for Kids';
export const BIRTHDAY_FOR_TEENS_CATEGORY = 'Birthday for Teens';
export const ADULTS_BIRTHDAY_CATEGORY = 'Birthday for Adults';
export const WEDDING_CATEGORY = 'Wedding';
export const GRADUATION_CATEGORY = 'Graduation';
export const FUNERAL_CATEGORY = 'Funeral';

// Event types
export const FUNERAL_MEMORIAL_EVENT_TYPE = 'funeral_memorial_service';

export const JULY_FOURTH_EVENT_TYPE = 'july_fourth';
export const BBQ_EVENT_TYPE = 'bbq';
export const BEACH_PARTY_EVENT_TYPE = 'beach_party';
export const FATHERS_DAY_EVENT_TYPE = 'fathers_day';
export const LABOR_DAY_EVENT_TYPE = 'labor_day';
export const MEMORIAL_DAY_EVENT_TYPE = 'memorial_day';

export const BRIDAL_SHOWER_EVENT_TYPE = 'bridal_shower';
export const ENGAGEMENT_EVENT_TYPE = 'engagement';
export const WEDDINGS_EVENT_TYPE = 'weddings';
export const WELCOME_RECEPTION_EVENT_TYPE = 'welcome_reception';
export const WEDDING_SAVE_THE_DATE_EVENT_TYPE = 'wedding_save_the_date';

export const BIRTHDAY_FOR_ADULTS_EVENT_TYPE = 'birthday_foradults';
export const BIRTHDAY_FOR_HER_EVENT_TYPE = 'birthday_forher';
export const BIRTHDAY_FOR_HIM_EVENT_TYPE = 'birthday_forhim';
export const BIRTHDAY_MILESTONES_EVENT_TYPE = 'birthday_milestones';
export const BIRTHDAY_FOR_TEENS_EVENT_TYPE = 'birthday_forteens';
export const BIRTHDAY_FOR_KIDS_EVENT_TYPE = 'birthday_forkids';

export const BABY_SPRINKLE_EVENT_TYPE = 'baby_sprinkle';
export const BABY_SHOWER_EVENT_TYPE = 'baby_shower';
export const GENDER_REVEAL_EVENT_TYPE = 'gender_reveal';
export const SIP_AND_SEE_EVENT_TYPE = 'sip_and_see';
export const BABY_SAVE_THE_DATE_EVENT_TYPE = 'baby_save_the_date';
export const BABYS_FIRST_EVENT_TYPE = 'babys_first';

export const GRADUATION_EVENT_TYPE = 'graduation';

// Event type groups
export const OUTDOOR_GATHERING_EVENT_TYPES = [
  JULY_FOURTH_EVENT_TYPE,
  BBQ_EVENT_TYPE,
  BEACH_PARTY_EVENT_TYPE,
  FATHERS_DAY_EVENT_TYPE,
  LABOR_DAY_EVENT_TYPE,
  MEMORIAL_DAY_EVENT_TYPE,
];

export const WEDDING_EVENT_TYPES = [
  BRIDAL_SHOWER_EVENT_TYPE,
  ENGAGEMENT_EVENT_TYPE,
  WEDDINGS_EVENT_TYPE,
  WELCOME_RECEPTION_EVENT_TYPE,
  WEDDING_SAVE_THE_DATE_EVENT_TYPE,
];

export const ADULT_BIRTHDAY_EVENT_TYPES = [
  BIRTHDAY_FOR_ADULTS_EVENT_TYPE,
  BIRTHDAY_FOR_HER_EVENT_TYPE,
  BIRTHDAY_FOR_HIM_EVENT_TYPE,
  BIRTHDAY_MILESTONES_EVENT_TYPE,
];

export const BABY_EVENT_TYPES = [
  BABY_SPRINKLE_EVENT_TYPE,
  BABY_SHOWER_EVENT_TYPE,
  GENDER_REVEAL_EVENT_TYPE,
  SIP_AND_SEE_EVENT_TYPE,
  BABY_SAVE_THE_DATE_EVENT_TYPE,
];
